'use client';
import React, { useState } from 'react';
import { Heart, MessageCircle, Trophy } from 'lucide-react';
import { toast } from 'sonner';

const communityPosts = [
  {
    id: 'post-001',
    avatar: 'RN',
    avatarColor: 'bg-blue-500',
    name: 'Rahul N.',
    badge: '🏆 Win',
    badgeClass: 'badge-amber',
    time: '2h ago',
    text: 'Just completed my 30-day streak! The daily speaking tasks really work. I can feel the difference in my confidence.',
    likes: 24,
    comments: 8,
    liked: false,
  },
  {
    id: 'post-002',
    avatar: 'KL',
    avatarColor: 'bg-rose-500',
    name: 'Kavitha L.',
    badge: '📣 Speaking',
    badgeClass: 'badge-green',
    time: '4h ago',
    text: 'Completed Day 17 speaking task — talked about my daily routine for 7 minutes! Couldn\'t stop 😄',
    likes: 18,
    comments: 5,
    liked: true,
  },
  {
    id: 'post-003',
    avatar: 'AM',
    avatarColor: 'bg-purple-500',
    name: 'Arjun M.',
    badge: '💡 Vocab',
    badgeClass: 'badge-blue',
    time: '6h ago',
    text: 'Word of the day: "Perseverance" — I used it in 5 different sentences today during practice!',
    likes: 31,
    comments: 12,
    liked: false,
  },
  {
    id: 'post-004',
    avatar: 'SD',
    avatarColor: 'bg-green-500',
    name: 'Sunita D.',
    badge: '🎯 Milestone',
    badgeClass: 'badge-purple',
    time: '8h ago',
    text: 'Finished Phase 1 of the Blueprint! Foundation complete. Moving to Speaking Activation 🚀',
    likes: 47,
    comments: 19,
    liked: false,
  },
];

export default function CommunityFeed() {
  const [posts, setPosts] = useState(communityPosts);

  const handleLike = (id: string) => {
    setPosts((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, liked: !p.liked, likes: p.liked ? p.likes - 1 : p.likes + 1 } : p
      )
    );
    toast.success('Liked! Keep encouraging your fellow learners 🎉');
  };

  return (
    <div className="rounded-2xl border border-border bg-card p-5 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-bold text-foreground">Community Wins</h3>
        <button className="text-xs font-semibold text-primary hover:underline">Open Community</button>
      </div>

      <div className="flex flex-col gap-3">
        {posts.map((post) => (
          <div key={post.id} className="p-3.5 rounded-xl border border-border hover:bg-muted/30 transition-all">
            {/* Header */}
            <div className="flex items-center gap-2.5 mb-2">
              <div
                className={`w-8 h-8 rounded-full ${post.avatarColor} flex items-center justify-center text-xs font-bold text-white flex-shrink-0`}
              >
                {post.avatar}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold text-foreground">{post.name}</span>
                  <span className={`${post.badgeClass} text-xs`}>{post.badge}</span>
                </div>
                <span className="text-xs text-muted-foreground">{post.time}</span>
              </div>
            </div>

            {/* Text */}
            <p className="text-xs text-foreground leading-relaxed mb-3">{post.text}</p>

            {/* Actions */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => handleLike(post.id)}
                className={`flex items-center gap-1.5 text-xs font-semibold transition-colors ${
                  post.liked ? 'text-red-500' : 'text-muted-foreground hover:text-red-500'
                }`}
              >
                <Heart size={13} className={post.liked ? 'fill-red-500' : ''} />
                {post.likes}
              </button>
              <button className="flex items-center gap-1.5 text-xs font-semibold text-muted-foreground hover:text-foreground transition-colors">
                <MessageCircle size={13} />
                {post.comments}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Post prompt */}
      <div className="flex items-center gap-3 p-3 rounded-xl bg-muted border border-border">
        <div className="w-7 h-7 rounded-full gradient-green flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
          PR
        </div>
        <button className="flex-1 text-left text-xs text-muted-foreground hover:text-foreground transition-colors">
          Share your win today...
        </button>
        <Trophy size={14} className="text-primary" />
      </div>
    </div>
  );
}